import { getHireJobsWorkedWithYouRetrieveQueryOptions } from "@sidegigllc/api/client";

/** Everything the endpoint will give: the step shows the best few but invites all of them. */
const WORKED_WITH_YOU_LIMIT = 50;

export const workedWithYouQuery = ({ jobId }: { jobId: string }) =>
  getHireJobsWorkedWithYouRetrieveQueryOptions(jobId, { limit: WORKED_WITH_YOU_LIMIT });
